import { BlankTemplate } from "../../../lib/model/addonTemplate";

export const blankTemplate: BlankTemplate = {
  id: "blank",
  title: "Blank Template",
  platforms: [],
  image: null,
  type: "blank",
  content: [],
};
